import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import useIntersectionObserver from '../../../hooks/useIntersectionObserver';

const styles = ({ position, spacing }) => () => ({
  position: 'sticky',
  top: position === 'top' && '-1px',
  bottom: position === 'bottom' && '-1px',
  zIndex: '10',
  border: '1px solid rgba(75, 75, 75, 0)',
  background: '#fff',
  transition: 'all 0.25s ease-in-out 0s',
  marginLeft: `-${spacing}px`,
  marginRight: `-${spacing}px`,
  marginTop: position === 'top' ? `-${spacing}px` : undefined,
  marginBottom: position === 'bottom' ? `-${spacing}px` : undefined,
  padding: '10px 30px',
  '&.dn-sticky-bottom': {
    zIndex: '110',
  },
  '&.dn-active': {
    borderTop: '1px solid rgba(75, 75, 75, 0.1)',
    borderBottom: '1px solid rgba(75, 75, 75, 0.1)',
    boxShadow: (
      position === 'top'
        ? '0px 4px 10px rgba(75, 75, 75, 0.1)'
        : '0 4px 0 4px #fff, 0 -4px 10px rgba(75, 75, 75, 0.1)'
    ),
  },
});

const Sticky = ({
  className,
  children,
  position = 'top',
  rootSelector = '.dn-filter .MuiPaper-root',
  spacing = '30',
}) => {
  const [stickyRef, stickyEntry] = useIntersectionObserver({
    rootMargin: '0px 0px 0px 0px',
    root: document.querySelector(rootSelector),
  });

  const stickyClasses = {
    [className]: true,
    'dn-sticky-box': true,
    'dn-active': stickyEntry?.intersectionRatio < 1,
  };

  return (
    <Box ref={stickyRef} sx={styles({ position, spacing })} className={stickyClasses}>
      {children}
    </Box>
  );
};

Sticky.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  position: PropTypes.string,
  spacing: PropTypes.string,
  rootSelector: PropTypes.string,
};

export default Sticky;
